import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/core/api/axios-client";
import type { ApiResponse } from "@/core/api/types/auth";

interface UnreadCountResponse {
  total: number;
}

const UNREAD_COUNT_QUERY_KEY = "unread-count";

export const useUnreadCount = (options: { enabled?: boolean } = {}) => {
  const { enabled = true } = options;

  const { data, isLoading } = useQuery({
    queryKey: [UNREAD_COUNT_QUERY_KEY],
    queryFn: async () => {
      const response = await apiClient.get<ApiResponse<UnreadCountResponse>>(
        "/notifications/unread-count"
      );
      return response.data.data.total;
    },
    enabled,
  });

  return {
    unreadCount: data || 0,
    isLoading,
  };
};
